import { getAllTotal } from '@/api/societe/index';
import { InitAgenceRattachement } from './getSocieteAgence';

function madeTitleAndIdAgence(societes) {
  const agences = [];
  societes.forEach((societe) => {
    societe.agences.forEach((agence) => {
      agences.push(
        {
          title: societe.libelle + ' - ' + agence.libelle,
          id: agence.id,
        },
      );
    });
  });
  return agences;
}

export async function getAgencesRattachement() {
  const responseGetAll = await getAllTotal();
  return madeTitleAndIdAgence(responseGetAll.data.result.items);
}

export function getNewAgenceRattachement(agenceRattachementId, societes, allAgencesId) {
  const societe = societes.find((societe) => {
    const agence = societe.agences.find((agence) => {
      return agence.disabled === true;
    });
    if (agence) {
      agence.selected = false;
      agence.disabled = false;
      const index = allAgencesId.indexOf(agenceRattachementId);
      allAgencesId.splice(index, 1);
    } return agence;
  });
  if (societe) {
    societe.disabled = false;
    const agence = societe.agences.find((agence) => {
      return agence.selected === true;
    });
    if (!agence) societe.selected = false;
  }
  const agence = allAgencesId.find((id) => {
    return id === agenceRattachementId;
  });
  if (!agence) allAgencesId.push(agenceRattachementId);
  InitAgenceRattachement(societes, agenceRattachementId);
}
